// Root-level React error boundary. Prevents future regressions from producing
// a blank white/black screen — surfaces the error and a "reload" action instead.
import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log for the developer console; a future rollout can pipe this to Sentry etc.
    console.error("OSRR error boundary caught:", error, info);
    this.setState({ info });
  }

  handleReload = () => {
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        className="min-h-screen bg-[#0A1128] text-white flex items-center justify-center px-6"
        data-testid="root-error-boundary"
      >
        <div className="max-w-lg w-full text-center">
          <div className="overline mb-3" style={{ color: "#D4AF37" }}>
            Something went off-key
          </div>
          <h1 className="font-display text-3xl lg:text-4xl tracking-tight">
            OSRR hit an unexpected error
          </h1>
          <p className="text-slate-300 mt-5 leading-relaxed">
            The page didn&apos;t render correctly. This is a bug, not a paywall — please
            try reloading. If it keeps happening, phone{" "}
            <span className="text-[#B8D0EE] notranslate">(310) 905-7115</span> and we&apos;ll
            look into it.
          </p>
          {this.state.error && (
            <pre className="mt-6 p-4 rounded-md border border-white/10 bg-black/40 text-left text-[11px] text-slate-400 overflow-auto max-h-40">
              {String(this.state.error?.message || this.state.error)}
            </pre>
          )}
          <button
            type="button"
            onClick={this.handleReload}
            className="btn-gold mt-8 inline-flex items-center gap-2"
            data-testid="error-boundary-reload"
          >
            Reload the registry
          </button>
        </div>
      </div>
    );
  }
}
